module.exports = __webpack_public_path__ + "static/media/login.5630972c.png";